export default function () {
    return {
        path: ['semanticAppVersions'],
        value: {}
    }
}
